export default {
  'notFound.title': 'A página que você está procurando não existe!',
  'notFound.subtitle': 'Se estiver com algum problema, entre em contato com o suporte da Btime'
}
